// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Person } from './person';
import { Proposal } from './proposal';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProposalVote extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  code?: string;
  created?: Date;
  createdBy?: string;
  deleted?: Date;
  noVote!: boolean;
  personId?: number;
  proposalId!: number;
  sent?: Date;
  userId?: number;
  viewed?: Date;
  voted?: Date;
  yesVote!: boolean;
  person!: Person;
  proposal!: Proposal;
  user!: User;
}

